import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import './ResponsiveBlocklyPhaserLayout.css';

interface ResponsiveBlocklyPhaserLayoutProps {
    blocklyComponent: React.ReactNode;
    phaserComponent: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

const ResponsiveBlocklyPhaserLayout: React.FC<ResponsiveBlocklyPhaserLayoutProps> = ({
    blocklyComponent,
    phaserComponent,
    className,
    style
}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width < 768);
            setIsTablet(width >= 768 && width < 1024);
        };

        // Check on mount
        checkScreenSize();

        // Add event listener for window resize
        window.addEventListener('resize', checkScreenSize);

        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // Mobile and tablet: Stack vertically (Blockly on top, Phaser below)
    if (isMobile || isTablet) {
        return (
            <div 
                className={`responsive-blockly-phaser-container ${className || ''}`} 
                style={{ ...style, height: '100%' }}
            >
                {/* Blockly Section - Top */}
                <div className="responsive-blockly-phaser-section blockly">
                    {blocklyComponent}
                </div>
                
                {/* Phaser Section - Bottom */}
                <div className="responsive-blockly-phaser-section phaser">
                    <div className="phaser-wrapper">
                        {phaserComponent}
                    </div>
                </div>
            </div>
        );
    }

    // Desktop: Side by side layout
    return (
        <div 
            className={`responsive-blockly-phaser-container desktop ${className || ''}`} 
            style={{ height: '100%', ...style }}
        >
            <Row gutter={16} style={{ height: '100%', width: '100%' }}>
                <Col span={16} style={{ height: '100%' }}>
                    <div className="responsive-blockly-phaser-section blockly">
                        {blocklyComponent}
                    </div>
                </Col>
                <Col span={8} style={{ height: '100%' }}>
                    <div className="responsive-blockly-phaser-section phaser">
                        <div className="phaser-wrapper">
                            {phaserComponent}
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ResponsiveBlocklyPhaserLayout;

